import { storage } from '../plugins/firebase'
import { store } from '../store'

export async function setProfilePics () {
  const newUsers = [...store.getters.users]
  const imgPromises = []
  newUsers.forEach((user) => {
    let imageRef
    if (user.photoUrl) {
      imageRef = storage.ref(user.photoUrl)
      imgPromises.push(imageRef.getDownloadURL())
    } else {
      imgPromises.push(Promise.resolve(null))
    }
  })
  
  const results = await Promise.all(
    imgPromises.map(promise => 
      promise
        .then(value => ({ status: 'fulfilled', value }))
        .catch(reason => ({ status: 'rejected', reason }))
    )
  )
  results.forEach((result, index) => {
    if (result.status === 'fulfilled' && result.value) {
      newUsers[index].profilePic = result.value
    } else {
      newUsers[index].profilePic = null
    }
  })
  store.commit('setUsers', newUsers)
}



// WEBPACK FOOTER //
// ./src/lib/setProfilePics.js